// wishlist-bubble.js

window.updateWishlistBubble = function () {
  const bubble = document.querySelector(".wishlist-bubble");
  const bubbleCount = bubble?.querySelector(".wishlist-bubble-count");

  if (!bubble || !bubbleCount) return;

  const wishlist = JSON.parse(localStorage.getItem("wishlist") || "[]");
  const count = wishlist.length;

  if (count === 0) {
    bubble.classList.add("visually-hidden");
  } else {
    bubble.classList.remove("visually-hidden");
    bubbleCount.textContent = count > 99 ? "99+" : count;
  }
};

document.addEventListener("DOMContentLoaded", window.updateWishlistBubble);

window.addEventListener("storage", (e) => {
  if (e.key === "wishlist") window.updateWishlistBubble();
});

// Re-assert wishlist bubble after morph.js runs on cart update
document.addEventListener('cart:update', () => {
  window.updateWishlistBubble?.();
});